import { PermissionState } from '@capacitor/core';

export namespace GeolocationPermission {
  export enum MSPermissionStatus {
    GRANTED = 0,
    PROMPT = 1,
    PROMPT_WITH_RATIONAL = 2,
    DENIED = 3,
    DISABLE = 4
  }

  export function convertPermissionStatus(permissionState: PermissionState): MSPermissionStatus {
    switch (permissionState) {
      case 'granted':
        return MSPermissionStatus.GRANTED;
      case 'prompt':
        return MSPermissionStatus.PROMPT;
      case 'prompt-with-rationale':
        return MSPermissionStatus.PROMPT_WITH_RATIONAL;
      case 'denied':
        return MSPermissionStatus.DENIED;
      default:
        return MSPermissionStatus.DISABLE;
    }
  }

  export function getGreaterPermissionStatus(status1: MSPermissionStatus, status2: MSPermissionStatus): MSPermissionStatus {
    if (status1 > status2) {
      return status1;
    } else {
      return status2;
    }
  }
}
